import Vue from 'vue';
import { $http } from '@/utils/https'
import {
    SET_LOADING_PRODUCTS_LIST,
    SET_PRODUCTS_LIST,
    UPDATE_CHECKED_LIST_IN_PRODUCTS,
    PRODUCTS_CHANGE_SKIP,
    PRODUCTS_SET_COUNT,
    ACTIVE_CATEGORY,
    REMOVE_FILTER_ITEM_IN_SEARCH,
    PRODUCTS_CHANGE_LIMIT,
    PRODUCTS_CHANGE_VIEW,
    SET_CUSTOM_BREADCRUMBS_LIST,
    SET_PRODUCTS_SORT_TYPE
} from '../mutation-types';
import _ from 'lodash'
import {
    GET_PRODUCTS_LIST,
    GET_CUSTOM_BREADCRUMBS
} from '../action-types';


const state = {
    viewType: localStorage.getItem('viewType') ? JSON.parse(localStorage.getItem('viewType')) : 'tile',
    list: null,
    listLoading: false,

    selectedSortType: null,

    activeCategory: '',

    checkedList: [],

    skip: 0,
    count: 0,
    limit: 6,
};

const getters = {
    viewType: state => state.viewType,
    selectedSortType: state => state.selectedSortType,
    list: state => state.list,
    skip: state => state.skip,
    count: state => state.count,
    limit: state => state.limit,
    listLoading: state => state.listLoading,
    activeCategory: state => state.activeCategory,

    checkedList: state => state.checkedList,
};

const actions = {
    [GET_PRODUCTS_LIST]: async ({ commit }, payload) => {
        commit(SET_LOADING_PRODUCTS_LIST, true);
        try {
            const response = await $http.post(`v1/category/${payload.slug}/products?include=breadcrumbs,products&limit=${state.limit}&skip=${state.skip}&sort=${state.selectedSortType.key}`, payload.data);

            commit(SET_PRODUCTS_LIST, response.data.data);
            commit(PRODUCTS_SET_COUNT, response.data.meta.count);
        }catch (e) {
            throw e;
        }finally {
            commit(SET_LOADING_PRODUCTS_LIST, false);
        }
    },
    [GET_CUSTOM_BREADCRUMBS]: async ({ commit }, payload) => {
        try {
            const response = await $http.get(`v1/category/${payload.slug}?include=breadcrumbs`);

            commit(`system/${SET_CUSTOM_BREADCRUMBS_LIST}`, response.data.data, { root: true });
        }catch (e) {
            throw e;
        }
    },
};

const mutations = {
    [SET_PRODUCTS_LIST](state, list) {
        state.list = list;
    },
    [SET_PRODUCTS_SORT_TYPE](state, data) {
        state.selectedSortType = data;
    },
    [PRODUCTS_CHANGE_VIEW](state, key) {
        state.viewType = key;
        const parsed = JSON.stringify(state.viewType);
        localStorage.setItem('viewType', parsed);
    },
    [SET_LOADING_PRODUCTS_LIST](state, status) {
        state.listLoading = status;
    },
    [ACTIVE_CATEGORY](state, activeCategory) {
        state.activeCategory = activeCategory;
    },
    [PRODUCTS_CHANGE_SKIP](state, skip) {
        state.skip = skip;
    },
    [PRODUCTS_CHANGE_LIMIT](state, limit) {
        state.limit = limit;
    },
    [PRODUCTS_SET_COUNT](state, count) {
        state.count = count;
    },
    [REMOVE_FILTER_ITEM_IN_SEARCH](state, data) {
        const elem = _.find(state.checkedList, e => e.slug === data.item);
        const indexMain = _.findIndex(state.checkedList, e => e.slug === data.item);

        _.remove(elem.categories, e => e.slug === data.subItem);

        Vue.set(state.checkedList, indexMain, elem);
        if(state.checkedList[indexMain].categories.length === 0){
            _.remove(state.checkedList, e => e.slug === data.item);
        }

    },
    [UPDATE_CHECKED_LIST_IN_PRODUCTS](state, data) {
        const elem = _.find(state.checkedList, ['slug', data.slug]);
        if(elem){
            if(elem.categories.length !== 0){
                const index = _.findIndex(state.checkedList, e => e.slug === data.slug);
                Vue.set(state.checkedList, index, data);

                if(state.checkedList[index].categories.length === 0){
                    _.remove(state.checkedList, e => e.slug === data.slug);
                }
            }
        }else{
            state.checkedList.push(data);
        }
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
